module.exports = __webpack_public_path__ + "static/media/bigpic-sub-01.99206417.jpg";